
(function () {
  'use strict';

  var CSS = '' +
  '.sr-wrap{--sr-ink:#101014;--sr-mut:#6b7280;--sr-line:#e6e8ea;--sr-bg:#f6f7f8;--sr-blue:#1a3399;--sr-blue-bg:#eef1fb;' +
    'font-family:"Manrope",-apple-system,sans-serif;color:var(--sr-ink);line-height:1.5;display:grid;grid-template-columns:1.15fr 1fr;gap:38px}' +
  '@media (max-width:900px){.sr-wrap{grid-template-columns:1fr}}' +
  '.sr-kicker{font-size:12px;font-weight:700;letter-spacing:.09em;text-transform:uppercase;color:var(--sr-mut);margin:0 0 8px}' +
  '.sr-desc h2{font-size:23px;font-weight:700;line-height:1.3;letter-spacing:-.01em;margin:0 0 14px}' +
  '.sr-desc p{font-size:14.5px;color:#374151;margin:0 0 12px;max-width:62ch}' +
  '.sr-quick{display:flex;flex-wrap:wrap;gap:7px;margin:0 0 16px}' +
  '.sr-qbadge{font-size:12.5px;font-weight:700;background:var(--sr-blue-bg);color:var(--sr-blue);border-radius:999px;padding:5px 13px}' +
  '.sr-features{display:grid;grid-template-columns:repeat(2,1fr);gap:10px;margin:22px 0 6px}' +
  '@media (max-width:560px){.sr-features{grid-template-columns:1fr}}' +
  '.sr-feature{display:flex;gap:11px;align-items:flex-start;background:var(--sr-bg);border-radius:12px;padding:14px 16px;transition:background .15s}' +
  '.sr-feature svg{width:20px;height:20px;flex:none;color:var(--sr-blue);margin-top:2px}' +
  '.sr-feature b{display:block;font-size:14px;font-weight:700}' +
  '.sr-feature span{font-size:12.5px;color:var(--sr-mut);display:-webkit-box;-webkit-line-clamp:3;-webkit-box-orient:vertical;overflow:hidden}' +
  '.sr-feature.sr-open span{-webkit-line-clamp:unset}' +
  '.sr-feature.sr-more{cursor:pointer}' +
  '.sr-feature.sr-more:hover{background:#eef0f3}' +
  '.sr-feature .sr-hint{display:none;font-size:11px;color:var(--sr-blue);font-weight:600;margin-top:3px}' +
  '.sr-feature.sr-more .sr-hint{display:block}' +
  '.sr-feature.sr-open .sr-hint-more,.sr-feature:not(.sr-open) .sr-hint-less{display:none}' +
  '.sr-summary{background:var(--sr-blue-bg);border-left:3px solid var(--sr-blue);border-radius:0 14px 14px 0;padding:16px 18px;margin-top:14px}' +
  '.sr-summary p{font-size:14px;color:#28303f;margin:0;max-width:none}' +
  '.sr-specs h2{font-size:20px;font-weight:700;margin:0 0 14px}' +
  '.sr-group{border:1px solid var(--sr-line);border-radius:14px;margin-bottom:10px;overflow:hidden;background:#fff}' +
  '.sr-group summary{display:flex;align-items:center;gap:10px;padding:12px 15px;font-size:13.5px;font-weight:700;cursor:pointer;list-style:none;user-select:none}' +
  '.sr-group summary::-webkit-details-marker{display:none}' +
  '.sr-group summary svg{width:17px;height:17px;flex:none;color:#4b5563}' +
  '.sr-group summary .sr-chev{margin-left:auto;transition:transform .18s;color:#9aa1a9}' +
  '.sr-group[open] summary .sr-chev{transform:rotate(180deg)}' +
  '.sr-group[open] summary{border-bottom:1px solid var(--sr-line)}' +
  '.sr-row{display:flex;justify-content:space-between;gap:16px;padding:8px 15px;font-size:13px}' +
  '.sr-row:nth-child(even){background:var(--sr-bg)}' +
  '.sr-row .k{color:var(--sr-mut)}' +
  '.sr-row .v{font-weight:600;text-align:right;max-width:58%}' +
  '.sr-row.long{flex-direction:column;gap:2px}' +
  '.sr-row.long .v{text-align:left;max-width:none;font-weight:500}' +
  '.sr-dot{display:inline-block;width:11px;height:11px;border-radius:50%;border:1px solid rgba(0,0,0,.15);vertical-align:-1px;margin-right:6px}' +
  '.sr-tags{display:flex;flex-wrap:wrap;gap:7px;padding:13px 15px}' +
  '.sr-tag{font-size:12.5px;font-weight:600;background:#fbfbfc;border:1px solid var(--sr-line);border-radius:999px;padding:5px 13px;transition:background .15s,border-color .15s}' +
  '.sr-tag:hover{background:var(--sr-blue-bg);border-color:var(--sr-blue)}' +
  '.sr-dims{display:flex;align-items:center;gap:20px;padding:14px 16px}' +
  '.sr-dims svg .frame{stroke:#9aa1a9;fill:#fbfbfc}' +
  '.sr-dims svg .glyph{stroke:#c3c8cd;fill:none}' +
  '.sr-dims svg .meas{stroke:#c3c8cd}' +
  '.sr-dims svg text{font-size:10px;fill:var(--sr-mut)}' +
  '.sr-dimlist{display:grid;gap:4px;font-size:13px}' +
  '.sr-dimlist span{color:var(--sr-mut)}' +
  '.sr-dimlist b{font-weight:700;margin-left:6px}';

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  var ICONS = [
    [/ener/i, 'M13 3L4 14h6l-1 7 9-11h-6l1-7z'],
    [/izm|svars/i, 'M21 3H3v18h18V3zM21 9H3M9 21V9'],
    [/program/i, 'M4 6h16M4 12h10M4 18h7'],
    [/dro/i, 'M12 3l7 3v5c0 4.5-3 8.5-7 10-4-1.5-7-5.5-7-10V6l7-3z'],
    [/vad/i, 'M4 8h10M18 8h2M14 8a2 2 0 104 0 2 2 0 00-4 0zM4 16h2M10 16h10M6 16a2 2 0 104 0 2 2 0 00-4 0z'],
    [/ietilp|tilp|centrif/i, 'M4 8l8-5 8 5v8l-8 5-8-5V8zM4 8l8 5 8-5M12 13v8'],
    [/žāv|zav/i, 'M12 5a5 5 0 100 10 5 5 0 000-10zM12 1v2M12 17v2M4.2 4.2l1.4 1.4M18.4 18.4l1.4 1.4M1 12h2M17 12h2'],
    [/unik|īpaš/i, 'M12 3l2.2 5.4L20 9l-4.4 3.9L17 19l-5-3.2L7 19l1.4-6.1L4 9l5.8-.6L12 3z'],
  ];
  var DEF_ICON = 'M4 5h16v14H4zM8 9h8M8 13h5';
  function iconFor(name) {
    for (var i = 0; i < ICONS.length; i++) if (ICONS[i][0].test(name)) return ICONS[i][1];
    return DEF_ICON;
  }
  var FICONS = [
    [/ai |ai$|smart|intel|čip/i, 'M9 3v3M15 3v3M9 18v3M15 18v3M3 9h3M3 15h3M18 9h3M18 15h3M6 6h12v12H6zM9.5 9.5h5v5h-5z'],
    [/steam|tvaik/i, 'M7 20c0-2.5 1.6-3 1.6-5S7 12.5 7 10.5 8.6 7.5 8.6 5.5M12 20c0-2.5 1.6-3 1.6-5s-1.6-2.5-1.6-4.5 1.6-3 1.6-5M17 20c0-2.5 1.6-3 1.6-5S17 12.5 17 10.5s1.6-3 1.6-5'],
    [/wi-?fi|thinq|app|lietotn/i, 'M2 9c5.5-5.5 14.5-5.5 20 0M5.5 12.5c3.6-3.6 9.4-3.6 13 0M9 16c1.8-1.8 4.2-1.8 6 0M12 19.5h.01'],
    [/motor|drive|invert/i, 'M12 8a4 4 0 100 8 4 4 0 000-8zM12 2v3M12 19v3M2 12h3M19 12h3M4.9 4.9l2.1 2.1M17 17l2.1 2.1M19.1 4.9L17 7M7 17l-2.1 2.1'],
    [/dry|žāv|heat pump/i, 'M12 5a5 5 0 100 10 5 5 0 000-10zM12 1v2M12 17v2M4.2 4.2l1.4 1.4M18.4 18.4l1.4 1.4M1 12h2M17 12h2'],
    [/turbo|quick|ātr|wash/i, 'M13 3L4 14h6l-1 7 9-11h-6l1-7z'],
    [/tower|dizain|design/i, 'M4 8l8-5 8 5v8l-8 5-8-5V8z'],
  ];
  var FDEF = 'M12 3l2.2 5.4L20 9l-4.4 3.9L17 19l-5-3.2L7 19l1.4-6.1L4 9l5.8-.6L12 3z';
  function ficonFor(name) {
    for (var i = 0; i < FICONS.length; i++) if (FICONS[i][0].test(name)) return FICONS[i][1];
    return FDEF;
  }
  function svg(p) {
    return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="' + p + '"/></svg>';
  }

  // цветовой кружок для значений цвета (Krāsa, Durvju krāsa)
  var COLOR_MAP = [
    [/melna|black/i, '#1a1a1e'], [/balta|white/i, '#f4f4f4'], [/pelēka|grey|gray|graphite|grafīta/i, '#8a8f96'],
    [/sudraba|silver|inox|nerūs/i, '#c8ccd2'], [/zila|blue/i, '#3b5bb5'], [/zaļa|green/i, '#3f7a52'],
    [/sarkana|red/i, '#b53b3b'], [/bēša|beige|smilšu/i, '#d9c9a8'], [/brūna|brown/i, '#7a5c42'],
  ];
  function colorDot(key, value) {
    if (!/krāsa/i.test(key)) return '';
    for (var i = 0; i < COLOR_MAP.length; i++) if (COLOR_MAP[i][0].test(value)) return '<span class="sr-dot" style="background:' + COLOR_MAP[i][1] + '"></span>';
    return '';
  }

  // Quick Specs: 4-6 бейджей из ключевых характеристик, категорийно-независимо
  var QUICK_PICKS = [
    { re: /^maksimālā veļas ietilpība$/i, fmt: function (v) { return v; } },
    { re: /^žāvēšanas ietilpība$/i, fmt: function (v) { return /^nav/i.test(v) ? null : v + ' žāvēšana'; } },
    { re: /^maksimālais centrifūgas ātrums$/i, fmt: function (v) { return v.replace(' apgr./min', ' apgr./min'); } },
    { re: /^ekrāna diagonāle|^ekrāna izmērs/i, fmt: function (v) { return v; } },
    { re: /^kopējais tilpums$/i, fmt: function (v) { return v; } },
    { re: /^žāvēšanas tips$/i, fmt: function (v) { return /heat pump|siltumsūk/i.test(v) ? 'Heat Pump' : null; } },
    { re: /^wi-fi/i, fmt: function (v) { return /^ir/i.test(v) ? 'Wi-Fi' : null; } },
  ];
  function quickSpecs(groups) {
    var out = [];
    QUICK_PICKS.forEach(function (q) {
      if (out.length >= 6) return;
      groups.forEach(function (g) {
        (g.rows || []).forEach(function (p) {
          if (out.length >= 6) return;
          if (q.re.test(p[0])) { var b = q.fmt(String(p[1])); if (b && out.indexOf(b) === -1) out.push(b); }
        });
      });
    });
    var eb = energyBadge(groups);
    if (eb && out.indexOf(eb) === -1) out.splice(Math.min(3, out.length), 0, eb);
    return out.slice(0, 6);
  }
  function energyBadge(groups) {
    var combined = null, wash = null;
    groups.forEach(function (g) {
      (g.rows || []).forEach(function (p) {
        var k = String(p[0]).toLowerCase();
        if (/klase/.test(k) && ((k.indexOf('mazgāšana') !== -1 && k.indexOf('žāvēšana') !== -1) || k.indexOf('pilns cikls') !== -1)) combined = p[1];
        else if (k === 'energoefektivitātes klase') wash = p[1];
      });
    });
    var v = combined || wash;
    return v ? v + ' klase' : null;
  }
  var CHEV = '<svg class="sr-chev" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M6 9l6 6 6-6"/></svg>';

  function num(v) { var m = String(v).replace(',', '.').match(/[\d.]+/); return m ? parseFloat(m[0]) : null; }
  function extractDims(groups) {
    for (var i = 0; i < groups.length; i++) {
      var g = groups[i];
      if (!/izm/i.test(g.n)) continue;
      var H = null, W = null, D = null;
      (g.rows || []).forEach(function (p) {
        var kl = p[0].toLowerCase();
        if (/augstums/.test(kl) && H == null) H = num(p[1]);
        else if (/platums/.test(kl) && W == null) W = num(p[1]);
        else if (/dziļums|dzilums/.test(kl) && D == null && !/durv|lūk/.test(kl)) D = num(p[1]);
      });
      if (H && W) return { H: H, W: W, D: D };
    }
    return null;
  }
  function glyphFor(pt) {
    var t = String(pt || '').toLowerCase();
    if (/veļas maš|velas mas/.test(t)) return 'drum';
    if (/ledusskap|saldētav/.test(t)) return 'fridge';
    if (/televizor/.test(t)) return 'tv';
    return 'box';
  }
  function fmtN(v) { return String(Math.round(v * 10) / 10).replace('.', ','); }
  function dimsSVG(d, pt) {
    // холст с запасом: слева до 5 цифр («165,5»), снизу подпись ширины,
    // справа глубина — высокие «башни» больше ничего не обрезают
    var maxW = 96, maxH = 100, ratio = d.W / d.H, w, h;
    if (ratio > maxW / maxH) { w = maxW; h = maxW / ratio; } else { h = maxH; w = maxH * ratio; }
    w = Math.max(w, 26); h = Math.max(h, 20);
    var x = 46, y = 8, cx = x + w / 2;
    var glyph = '', g = glyphFor(pt);
    if (g === 'drum') { var r = Math.min(w, h) * 0.3; glyph = '<circle class="glyph" cx="' + cx + '" cy="' + (y + h * 0.55) + '" r="' + r + '"/><circle class="glyph" cx="' + cx + '" cy="' + (y + h * 0.55) + '" r="' + (r * 0.62) + '"/>'; }
    else if (g === 'fridge') { var sy = y + h * 0.42; glyph = '<line class="glyph" x1="' + x + '" y1="' + sy + '" x2="' + (x + w) + '" y2="' + sy + '"/>'; }
    else if (g === 'tv') { glyph = '<rect class="glyph" x="' + (x + w * 0.06) + '" y="' + (y + h * 0.08) + '" width="' + (w * 0.88) + '" height="' + (h * 0.7) + '"/>'; }
    return '<svg width="185" height="145" viewBox="0 0 185 145">' +
      '<rect class="frame" x="' + x + '" y="' + y + '" width="' + w + '" height="' + h + '" rx="3"/>' + glyph +
      '<line class="meas" x1="' + (x - 9) + '" y1="' + y + '" x2="' + (x - 9) + '" y2="' + (y + h) + '"/>' +
      '<text x="' + (x - 14) + '" y="' + (y + h / 2) + '" text-anchor="end" dominant-baseline="middle">' + fmtN(d.H) + '</text>' +
      '<line class="meas" x1="' + x + '" y1="' + (y + h + 10) + '" x2="' + (x + w) + '" y2="' + (y + h + 10) + '"/>' +
      '<text x="' + cx + '" y="' + (y + h + 22) + '" text-anchor="middle">' + fmtN(d.W) + '</text>' +
      (d.D ? '<text x="' + (x + w + 8) + '" y="' + (y + h) + '">&#8600; ' + fmtN(d.D) + '</text>' : '') +
      '</svg>';
  }

  function render(mount, data, opts) {
    opts = opts || {};
    if (!document.getElementById('sr-css')) {
      var st = document.createElement('style');
      st.id = 'sr-css'; st.textContent = CSS;
      document.head.appendChild(st);
    }
    var groups = data.groups || [];
    // фичи + дедупликация: «AI DD™» / «AI DD™ tehnoloģija» / «AI Direct
    // Drive™» = одна технология; выигрывает вариант с богатым текстом
    var FEAT_ALIAS = [
      [/ais*dd|ais*directs*drive/, 'ai-dd'],
      [/duals*inverters*heats*pump|heats*pump/, 'heat-pump'],
      [/thinq/, 'thinq'], [/turbowash/, 'turbowash'], [/steam|tvaik/, 'steam'],
      [/washtower/, 'washtower'], [/6s*motion/, '6motion'], [/ecobubble/, 'ecobubble'],
    ];
    function featBase(name) {
      var n = String(name || '').toLowerCase().replace(/[™®]/g, '').replace(/s+(tehnoloģija|dizains|funkcija)(s|$)/i, ' ').trim();
      for (var i = 0; i < FEAT_ALIAS.length; i++) if (FEAT_ALIAS[i][0].test(n)) return FEAT_ALIAS[i][1];
      return n;
    }
    var feats = [];
    var featIdx = {};
    groups.forEach(function (g) {
      if (g.mode !== 'features') return;
      (g.features || []).forEach(function (f) {
        var base = featBase(f.n);
        var prev = featIdx[base];
        if (prev != null) {
          // дубль: оставляем вариант с более содержательным текстом
          if ((f.t || '').length > (feats[prev].t || '').length) feats[prev] = f;
          return;
        }
        featIdx[base] = feats.length;
        feats.push(f);
      });
    });
    var dims = extractDims(groups);
    var quick = quickSpecs(groups);

    var specsHtml = '';
    groups.forEach(function (g, gi) {
      if (g.mode === 'features') return;
      var body = '';
      var isDims = /izm/i.test(g.n);
      if (isDims && dims) {
        body += '<div class="sr-dims">' + dimsSVG(dims, data.productType) + '<div class="sr-dimlist">' +
          '<div><span>Augstums</span><b>' + fmtN(dims.H) + ' cm</b></div>' +
          '<div><span>Platums</span><b>' + fmtN(dims.W) + ' cm</b></div>' +
          (dims.D ? '<div><span>Dziļums</span><b>' + fmtN(dims.D) + ' cm</b></div>' : '') + '</div></div>';
      }
      (g.rows || []).forEach(function (p) {
        var k = p[0], v = p[1];
        if (isDims && dims && /^(augstums|platums|dziļums|izmēri [(]kombinēti[)])$/i.test(String(k).trim())) return; // tikai precīzi dubli; "Dziļums ar durvīm" u.c. paliek
        var long = (k + String(v)).length > 62;
        body += '<div class="sr-row' + (long ? ' long' : '') + '"><span class="k">' + esc(k) + '</span><span class="v">' + colorDot(k, String(v)) + esc(v) + '</span></div>';
      });
      if ((g.tags || []).length) body += '<div class="sr-tags">' + g.tags.map(function (t) { return '<span class="sr-tag">' + esc(t) + '</span>'; }).join('') + '</div>';
      if (!body) return;
      specsHtml += '<details class="sr-group"' + (gi < 2 || isDims ? ' open' : '') + '><summary>' + svg(iconFor(g.n)) + esc(g.n) + CHEV + '</summary>' + body + '</details>';
    });

    var featHtml = feats.length ? '<div class="sr-features">' + feats.map(function (f) {
      return '<div class="sr-feature">' + svg(ficonFor(f.n || '')) + '<div><b>' + esc(f.n) + '</b>' + (f.t ? '<span>' + esc(f.t) + '</span>' : '') +
        '<div class="sr-hint"><span class="sr-hint-more">vair&#257;k &#8595;</span><span class="sr-hint-less">maz&#257;k &#8593;</span></div></div></div>';
    }).join('') + '</div>' : '';

    mount.innerHTML =
      '<div class="sr-wrap">' +
        '<article class="sr-desc">' +
          '<h2>' + esc(data.title || '') + '</h2>' +
          (quick.length ? '<div class="sr-quick">' + quick.map(function (q) { return '<span class="sr-qbadge">' + esc(q) + '</span>'; }).join('') + '</div>' : '') +
          (data.intro || []).map(function (t) { return '<p>' + esc(t) + '</p>'; }).join('') +
          featHtml +
          ((data.summary || []).length ? '<div class="sr-summary"><p class="sr-kicker" style="color:var(--sr-blue)">Kopsavilkums</p><p>' + esc(data.summary.join(' ')) + '</p></div>' : '') +
        '</article>' +
        '<aside class="sr-specs"><h2>Specifik&#257;cijas</h2>' + specsHtml + '</aside>' +
      '</div>';

    // длинные тексты фич: 3 строки + «vairāk» по клику (только там, где
    // текст реально не влез — короткие карточки не кликабельны)
    Array.prototype.forEach.call(mount.querySelectorAll('.sr-feature'), function (card) {
      var sp = card.querySelector('span');
      if (!sp) return;
      if (sp.scrollHeight > sp.clientHeight + 3) {
        card.classList.add('sr-more');
        card.addEventListener('click', function () { card.classList.toggle('sr-open'); });
      }
    });
  }

  window.SpecsRenderer = { render: render, css: CSS };
})();
